import { BaseMeasures } from './BaseMeasures.ts';

export const CollabEditProviderMeasures = new BaseMeasures();
